import React, {useState} from 'react';
import AurLoadingIndicator from '../../../common/aur-loading-indicator/AurLoadingIndictor';
import AurButton from '../../../common/aur-button/AurButton';
import {Box, Grid} from '@mui/material';
import {Link} from 'react-router-dom';

const LoadingIndicator: React.FC = () => {
  const [showLoader, setShowLoader] = useState(false);

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Loading Indicator</h1>
        <div>
          Progress indicators commonly known as spinners, express an unspecified
          wait time or display the length of a process.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurButton
            type="continue"
            label={showLoader ? 'Hide Loader' : 'Show Loader'}
            size="Large"
            onClick={() => {
              setShowLoader(!showLoader);
            }}
          />
          <br />
          <br />
          <Box>
            <Grid
              container
              spacing={2}
              sx={{paddingTop: '16px', paddingLeft: '15px'}}
            >
              <Grid
                item
                xs={6}
                sx={{border: '1px solid white', padding: '24px 0px !important'}}
              >
                <AurLoadingIndicator show={showLoader} />
              </Grid>
              <Grid
                item
                xs={4}
                sx={{border: '1px solid white', padding: '24px 0px !important'}}
              >
                <AurLoadingIndicator show={showLoader} />
              </Grid>
              <Grid
                item
                xs={2}
                sx={{border: '1px solid white', padding: '24px 0px !important'}}
              >
                <AurLoadingIndicator show={showLoader} />
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>
    </>
  );
};

export default LoadingIndicator;
